/**
 * customer API — generated from HAR captures.
 * Regenerate: npm run api:from-har
 */
import { apihubGet, apihubPost, apihubPut, apihubPatch, apihubDelete, apihubUpload } from "./apihub";
import { buildPath, withQuery } from "./paths";

/** DELETE `/getInteractedCustomerDetail/deleteattribute/:id` */
export function deleteDeleteattributeById(params, payload = {}) {
  return apihubDelete(buildPath('/getInteractedCustomerDetail/deleteattribute/:id', params), payload);
}

/** DELETE `/getInteractedCustomerDetail/deletesmsconfig/:id` */
export function deleteDeletesmsconfigById(params, payload = {}) {
  return apihubDelete(buildPath('/getInteractedCustomerDetail/deletesmsconfig/:id', params), payload);
}

/** DELETE `/getInteractedCustomerDetail/deletetag/:id` */
export function deleteDeletetagById(params, payload = {}) {
  return apihubDelete(buildPath('/getInteractedCustomerDetail/deletetag/:id', params), payload);
}

/** DELETE `/getInteractedCustomerDetail/deletetemplate` */
export function deleteDeletetemplate(payload = {}) {
  return apihubDelete('/getInteractedCustomerDetail/deletetemplate', payload);
}

/** GET `/getInteractedCustomerDetail/allannouncement` */
export function fetchAllannouncement() {
  return apihubGet('/getInteractedCustomerDetail/allannouncement');
}

/** GET `/getInteractedCustomerDetail/allcampaign/:phoneNoId` */
export function fetchAllcampaignByPhoneNoId(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/allcampaign/:phoneNoId', params), query));
}

/** GET `/getInteractedCustomerDetail/allnotification` */
export function fetchAllnotification() {
  return apihubGet('/getInteractedCustomerDetail/allnotification');
}

/** GET `/getInteractedCustomerDetail/allprojects` — user comes from auth token */
export function fetchAllProjects() {
  return apihubGet('/getInteractedCustomerDetail/allprojects');
}

/** @deprecated use fetchAllProjects — user is taken from the auth token */
export function fetchAllprojectsByEmail(_params) {
  return fetchAllProjects();
}

/** GET `/getInteractedCustomerDetail/campaigndetails/:id` */
export function fetchCampaigndetailsById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/campaigndetails/:id', params));
}

/** GET `/getInteractedCustomerDetail/fetchagent/:id` */
export function fetchFetchagentById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchagent/:id', params));
}

/** GET `/getInteractedCustomerDetail/fetchallteamroles` */
export function fetchFetchallteamroles() {
  return apihubGet('/getInteractedCustomerDetail/fetchallteamroles');
}

/** GET `/getInteractedCustomerDetail/fetchcannedmessage/:id` */
export function fetchFetchcannedmessageById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchcannedmessage/:id', params));
}

/** GET `/getInteractedCustomerDetail/fetchedalllearninghub` */
export function fetchFetchedalllearninghub() {
  return apihubGet('/getInteractedCustomerDetail/fetchedalllearninghub');
}

/** GET `/getInteractedCustomerDetail/fetchedallplans` */
export function fetchFetchedallplans() {
  return apihubGet('/getInteractedCustomerDetail/fetchedallplans');
}

/** GET `/getInteractedCustomerDetail/fetchedallplanswithcurrentplan/:id` */
export function fetchFetchedallplanswithcurrentplanById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchedallplanswithcurrentplan/:id', params));
}

/** POST `/getInteractedCustomerDetail/assign-project-plan` */
export function postAssignProjectPlan(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/assign-project-plan', payload);
}

/** GET `/getInteractedCustomerDetail/fetchedallurgentannouncement/:id` */
export function fetchFetchedallurgentannouncementById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchedallurgentannouncement/:id', params));
}

/** GET `/getInteractedCustomerDetail/fetchedcurrentlogo` */
export function fetchFetchedcurrentlogo() {
  return apihubGet('/getInteractedCustomerDetail/fetchedcurrentlogo');
}

/** GET `/getInteractedCustomerDetail/fetchlistofflow` */
export function fetchFetchlistofflow(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/fetchlistofflow', query));
}

/** GET `/getInteractedCustomerDetail/fetchprovidername/:id` */
export function fetchFetchprovidernameById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchprovidername/:id', params));
}

/** GET `/getInteractedCustomerDetail/fetchtagsbyprojectid/:id` */
export function fetchFetchtagsbyprojectidById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/fetchtagsbyprojectid/:id', params));
}

/** GET `/getInteractedCustomerDetail/getallflows` */
export function fetchGetallflows(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/getallflows', query));
}

/** GET `/getInteractedCustomerDetail/getarchivedcontactsdetailpaginated/` */
export function fetchGetarchivedcontactsdetailpaginated(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/getarchivedcontactsdetailpaginated/', query));
}

/** GET `/getInteractedCustomerDetail/getarchivedcontactsdetailpaginated/:phoneNoId` */
export function fetchGetarchivedcontactsdetailpaginatedByPhoneNoId(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/getarchivedcontactsdetailpaginated/:phoneNoId', params), query));
}

/** GET `/getInteractedCustomerDetail/getattributesdetail/` */
export function fetchGetattributesdetail() {
  return apihubGet('/getInteractedCustomerDetail/getattributesdetail/');
}

/** GET `/getInteractedCustomerDetail/getattributesdetail/:phoneNoId` */
export function fetchGetattributesdetailByPhoneNoId(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getattributesdetail/:phoneNoId', params));
}

/** GET `/getInteractedCustomerDetail/getattributesdetail/null` */
export function fetchGetattributesdetailnull() {
  return apihubGet('/getInteractedCustomerDetail/getattributesdetail/null');
}

/** GET `/getInteractedCustomerDetail/getcampaignstatusdata/:id/failed` */
export function fetchGetcampaignstatusdataByIdfailed(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/getcampaignstatusdata/:id/failed', params), query));
}

/** GET `/getInteractedCustomerDetail/getCustomerMessages/:id` */
export function fetchGetCustomerMessagesById(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/getCustomerMessages/:id', params), query));
}

/** GET `/getInteractedCustomerDetail/getInteractedCustomerdetailsCount/:phoneNoId` */
export function fetchGetInteractedCustomerdetailsCountByPhoneNoId(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getInteractedCustomerdetailsCount/:phoneNoId', params));
}

/** GET `/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/` */
export function fetchGetInteractedCustomersByBusinessId() {
  return apihubGet('/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/');
}

/** GET `/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/:phoneNoId` */
export function fetchGetInteractedCustomersByBusinessIdByPhoneNoId(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/:phoneNoId', params));
}

/** GET `/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/null` */
export function fetchGetInteractedCustomersByBusinessIdnull() {
  return apihubGet('/getInteractedCustomerDetail/getInteractedCustomersByBusinessId/null');
}

/** GET `/getInteractedCustomerDetail/getInteractedCustomersByBusinessIdPaginated/:phoneNoId` */
export function fetchGetInteractedCustomersByBusinessIdPaginatedByPhoneNoId(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/getInteractedCustomersByBusinessIdPaginated/:phoneNoId', params), query));
}

/** GET `/getInteractedCustomerDetail/getInteractedinactivecustomer/:phoneNoId` */
export function fetchGetInteractedinactivecustomerByPhoneNoId(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/getInteractedinactivecustomer/:phoneNoId', params), query));
}

/** GET `/getInteractedCustomerDetail/getoptinoutsetting/:id` */
export function fetchGetoptinoutsettingById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getoptinoutsetting/:id', params));
}

/** GET `/getInteractedCustomerDetail/getpaymentorders` */
export function fetchGetpaymentorders(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/getpaymentorders', query));
}

/** GET `/getInteractedCustomerDetail/get-team-of-project/:id` */
export function fetchGetTeamOfProjectById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/get-team-of-project/:id', params));
}

/** GET `/getInteractedCustomerDetail/gettotaltemplatesbyphonenumberid/` */
export function fetchGettotaltemplatesbyphonenumberid(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/gettotaltemplatesbyphonenumberid/', query));
}

/** GET `/getInteractedCustomerDetail/gettotaltemplatesbyphonenumberid/:phoneNoId` */
export function fetchGettotaltemplatesbyphonenumberidByPhoneNoId(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/gettotaltemplatesbyphonenumberid/:phoneNoId', params), query));
}

/** GET `/getInteractedCustomerDetail/getuserapikey/:id` */
export function fetchGetuserapikeyById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getuserapikey/:id', params));
}

/** GET `/getInteractedCustomerDetail/getusernameofmainbusiness/null` */
export function fetchGetusernameofmainbusinessnull() {
  return apihubGet('/getInteractedCustomerDetail/getusernameofmainbusiness/null');
}

/** GET `/getInteractedCustomerDetail/getwelcomeoffmessagepreferences/:id` */
export function fetchGetwelcomeoffmessagepreferencesById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getwelcomeoffmessagepreferences/:id', params));
}

/** GET `/getInteractedCustomerDetail/getwhatsapppayment` */
export function fetchGetwhatsapppayment(query) {
  return apihubGet(withQuery('/getInteractedCustomerDetail/getwhatsapppayment', query));
}

/** GET `/getInteractedCustomerDetail/getworkinghourspreferences/:id` */
export function fetchGetworkinghourspreferencesById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/getworkinghourspreferences/:id', params));
}

/** GET `/getInteractedCustomerDetail/profile` */
export function fetchProfile() {
  return apihubGet('/getInteractedCustomerDetail/profile');
}

/** GET `/getInteractedCustomerDetail/projects/:id` */
export function fetchProjectsById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/projects/:id', params));
}

/** GET `/getInteractedCustomerDetail/regenerateapikey/:id` */
export function fetchRegenerateapikeyById(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/regenerateapikey/:id', params));
}

/** GET `/getInteractedCustomerDetail/smstemplatebyid/:id` */
export function fetchSmstemplatebyidById(params, query) {
  return apihubGet(withQuery(buildPath('/getInteractedCustomerDetail/smstemplatebyid/:id', params), query));
}

/** GET `/getInteractedCustomerDetail/updatecustomerread/:customerId` */
export function fetchUpdatecustomerreadByCustomerId(params) {
  return apihubGet(buildPath('/getInteractedCustomerDetail/updatecustomerread/:customerId', params));
}

/** GET `/getInteractedCustomerDetail/updatecustomerread/null` */
export function fetchUpdatecustomerreadnull() {
  return apihubGet('/getInteractedCustomerDetail/updatecustomerread/null');
}

/** PATCH `/getInteractedCustomerDetail/updatecontact/:id` */
export function patchUpdatecontactById(params, payload = {}) {
  return apihubPatch(buildPath('/getInteractedCustomerDetail/updatecontact/:id', params), payload);
}

/** PATCH `/getInteractedCustomerDetail/updateroundrobin/:projectId` */
export function patchUpdateroundrobinByProjectId(params, payload = {}) {
  return apihubPatch(buildPath('/getInteractedCustomerDetail/updateroundrobin/:projectId', params), payload);
}

/** POST `/getInteractedCustomerDetail/changestatus` */
export function postChangestatus(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/changestatus', payload);
}

/** POST `/getInteractedCustomerDetail/createattribute` */
export function postCreateattribute(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/createattribute', payload);
}

/** POST `/getInteractedCustomerDetail/createbroadcastcampaign` */
export function postCreatebroadcastcampaign(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/createbroadcastcampaign', payload);
}

/** POST `/getInteractedCustomerDetail/createcampaignv2` */
export function postCreatecampaignv2(formData) {
  return apihubUpload('/getInteractedCustomerDetail/createcampaignv2', formData);
}

/** POST `/getInteractedCustomerDetail/createcannedmessage` */
export function postCreatecannedmessage(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/createcannedmessage', payload);
}

/** POST `/getInteractedCustomerDetail/createexcelcampaign` */
export function postCreateexcelcampaign(formData) {
  return apihubUpload('/getInteractedCustomerDetail/createexcelcampaign', formData);
}

/** POST `/getInteractedCustomerDetail/createtags` */
export function postCreatetags(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/createtags', payload);
}

/** POST `/getInteractedCustomerDetail/create-team-role` */
export function postCreateTeamRole(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/create-team-role', payload);
}

/** POST `/getInteractedCustomerDetail/deleteteamrole` */
export function postDeleteteamrole(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/deleteteamrole', payload);
}

/** POST `/getInteractedCustomerDetail/extractbusiness` */
export function postExtractbusiness(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/extractbusiness', payload);
}

/** POST `/getInteractedCustomerDetail/fetchallagentsbybusinessid/:id` */
export function postFetchallagentsbybusinessidById(params, payload = {}) {
  return apihubPost(buildPath('/getInteractedCustomerDetail/fetchallagentsbybusinessid/:id', params), payload);
}

/** POST `/getInteractedCustomerDetail/fetchallsmsconfig` */
export function postFetchallsmsconfig(query, payload = {}) {
  return apihubPost(withQuery('/getInteractedCustomerDetail/fetchallsmsconfig', query), payload);
}

/** POST `/getInteractedCustomerDetail/fetchlatestcampaign` */
export function postFetchlatestcampaign(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/fetchlatestcampaign', payload);
}

/** POST `/getInteractedCustomerDetail/fetchtotalsentmessagetype` */
export function postFetchtotalsentmessagetype(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/fetchtotalsentmessagetype', payload);
}

/** POST `/getInteractedCustomerDetail/getagentactivity` */
export function postGetagentactivity(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/getagentactivity', payload);
}

/** POST `/getInteractedCustomerDetail/getidandnameofcampaign` */
export function postGetidandnameofcampaign(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/getidandnameofcampaign', payload);
}

/** POST `/getInteractedCustomerDetail/gettotalremainingquota` */
export function postGettotalremainingquota(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/gettotalremainingquota', payload);
}

/** POST `/getInteractedCustomerDetail/importcontacts` */
export function postImportcontacts(formData) {
  return apihubUpload('/getInteractedCustomerDetail/importcontacts', formData);
}

/** POST `/getInteractedCustomerDetail/uploadcsvcontact` */
export function postUploadcsvcontact(formData) {
  return apihubUpload('/getInteractedCustomerDetail/uploadcsvcontact', formData);
}

/** POST `/getInteractedCustomerDetail/loginbusiness` */
export function postLoginbusiness(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/loginbusiness', payload);
}

/** POST `/getInteractedCustomerDetail/saveoptinout` */
export function postSaveoptinout(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/saveoptinout', payload);
}

/** POST `/getInteractedCustomerDetail/savepaymentgateway` */
export function postSavepaymentgateway(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/savepaymentgateway', payload);
}

/** POST `/getInteractedCustomerDetail/savesmsconfig` */
export function postSavesmsconfig(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/savesmsconfig', payload);
}

/** POST `/getInteractedCustomerDetail/savewelcomeoffmessage` */
export function postSavewelcomeoffmessage(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/savewelcomeoffmessage', payload);
}

/** POST `/getInteractedCustomerDetail/savewhatsapppayment` */
export function postSavewhatsapppayment(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/savewhatsapppayment', payload);
}

/** POST `/getInteractedCustomerDetail/saveworkinghours` */
export function postSaveworkinghours(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/saveworkinghours', payload);
}

/** POST `/getInteractedCustomerDetail/sendbroadcast` */
export function postSendbroadcast(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/sendbroadcast', payload);
}

/** POST `/getInteractedCustomerDetail/sendcampaignv2` */
export function postSendcampaignv2(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/sendcampaignv2', payload);
}

/** POST `/getInteractedCustomerDetail/toggletwofactorauthentication` */
export function postToggletwofactorauthentication(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/toggletwofactorauthentication', payload);
}

/** POST `/getInteractedCustomerDetail/update-customer-status` */
export function postUpdateCustomerStatus(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/update-customer-status', payload);
}

/** POST `/getInteractedCustomerDetail/updateprofileproject` */
export function postUpdateprofileproject(formData) {
  return apihubUpload('/getInteractedCustomerDetail/updateprofileproject', formData);
}

/** POST `/getInteractedCustomerDetail/updatesmsconfig/:id` */
export function postUpdatesmsconfigById(params, payload = {}) {
  return apihubPost(buildPath('/getInteractedCustomerDetail/updatesmsconfig/:id', params), payload);
}

/** POST `/getInteractedCustomerDetail/updateteamrole` */
export function postUpdateteamrole(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/updateteamrole', payload);
}

/** POST `/getInteractedCustomerDetail/webhookenabled` */
export function postWebhookenabled(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/webhookenabled', payload);
}

/** POST `/getInteractedCustomerDetail/webhookhit` */
export function postWebhookhit(payload = {}) {
  return apihubPost('/getInteractedCustomerDetail/webhookhit', payload);
}

/** PUT `/getInteractedCustomerDetail/logoutforagent/:id` */
export function putLogoutforagentById(params, payload = {}) {
  return apihubPut(buildPath('/getInteractedCustomerDetail/logoutforagent/:id', params), payload);
}

/** PUT `/getInteractedCustomerDetail/updatetag/:id` */
export function putUpdatetagById(params, payload = {}) {
  return apihubPut(buildPath('/getInteractedCustomerDetail/updatetag/:id', params), payload);
}
